export const FILTERS = [
  'Foody',
  'Green',
  'Online',
];